import type { UI } from '@/v2/types';

import { PartialPropertiesContent } from '@/v2/services/bff/getDestinationPage/getDestinationPage';

export type AddDestinationToPropertiesProps = {
  theme: UI.Destination;
  properties: Array<PartialPropertiesContent>;
  themeDestinations: UI.Destination[] | null;
};

const enrichThemePropertiesWithDestination = ({
  theme,
  properties,
  themeDestinations,
}: AddDestinationToPropertiesProps) => {
  // Set up lookup table for destinations by name
  const themeDestinationLookup = new Map<string, UI.Destination>();
  themeDestinations?.forEach((destination) =>
    themeDestinationLookup.set(destination.name, destination),
  );

  return properties.reduce(
    (
      acc: Array<PartialPropertiesContent>,
      property: PartialPropertiesContent,
    ) => {
      const propertyDestination = property.destinationName
        ? themeDestinationLookup.get(property.destinationName)
        : null;

      if (!propertyDestination) {
        return acc;
      }

      return [
        ...acc,
        {
          ...property,
          destination: {
            ...propertyDestination,
            country: propertyDestination.country ?? null,
          },
          theme: theme,
        },
      ];
    },
    [],
  );
};

export default enrichThemePropertiesWithDestination;
